import { HashiGameModel } from './hashi-game.model';

export class InitHashiGame {
  static readonly type = '[HashiGame] Init';
  constructor(public payload: HashiGameModel) {}
}

export class PersistHashiState {
  static readonly type = '[HashiGame] Persist game state';
  constructor(public payload: HashiGameModel) {}
}
